import * as IMAGES from './images';
import * as HELPS from './helps';
import * as DATES from './dates';
import * as ERRORS from './errors';
import * as AUTHORITIES from './authorities';
import * as PLAN from './plan';
import * as INJURY_STATUS from './injuryStatus';
import * as CSV from './csv';
import * as SEND_STATUS from './sendStatus';
import * as USERS from './users';

export default {
  IMAGES,
  HELPS,
  DATES,
  ERRORS,
  AUTHORITIES,
  PLAN,
  INJURY_STATUS,
  CSV,
  SEND_STATUS,
  USERS,
};
